// services/SessionTimer.js
import { getAuthData, isTokenExpired, onAuthUpdated } from './TokenManager';

let warnTimer = null;
let expireTimer = null;
let unsub = null;
let bc = null;

try { bc = new BroadcastChannel('session'); } catch (e) { /* BroadcastChannel no soportado */ }

const clearTimers = () => {
  if (warnTimer) { clearTimeout(warnTimer); warnTimer = null; }
  if (expireTimer) { clearTimeout(expireTimer); expireTimer = null; }
};

const schedule = (minutesBefore = 5) => {
  clearTimers();
  const a = getAuthData();
  if (!a?.expirationDate) return;

  const exp = new Date(a.expirationDate).getTime();
  const now = Date.now();
  const tokenDurationMs = exp - now;
  const tokenDurationMin = Math.floor(tokenDurationMs / (60 * 1000));

  // Validación inteligente: Para tokens cortos, ajustar warning dinámicamente
  let effectiveWarningMin = minutesBefore;

  if (tokenDurationMin <= minutesBefore) {
    // Para tokens <= 5 minutos: usar 80% de la duración como warning, mínimo 0.5 min
    effectiveWarningMin = Math.max(0.5, Math.floor(tokenDurationMin * 0.8 * 100) / 100);
  }

  const thresholdMs = effectiveWarningMin * 60 * 1000;
  const msUntilWarn = Math.max(0, tokenDurationMs - thresholdMs);
  const msUntilExpire = Math.max(0, tokenDurationMs);

  // Solo programa timers si hay tiempo suficiente
  if (tokenDurationMs > 0 && msUntilWarn >= 0) {
    warnTimer = setTimeout(() => {
      // solo una pestaña muestra la modal: usa BroadcastChannel para coordinar
      bc?.postMessage({ type: 'session:expiring' });
      window.dispatchEvent(new CustomEvent('session:expiring'));
    }, msUntilWarn);

    expireTimer = setTimeout(() => {
      bc?.postMessage({ type: 'session:expired' });
      window.dispatchEvent(new CustomEvent('session:expired'));
    }, msUntilExpire);

  }
};

export const startSessionTimer = (minutesBefore = 5) => {
  // programa al inicio
  schedule(minutesBefore);

  // reprograma cuando cambie el auth
  const off = onAuthUpdated(() => schedule(minutesBefore));
  unsub = () => { off(); clearTimers(); };

  // si otra pestaña avisa, replica eventos locales
  bc?.addEventListener('message', (e) => {
    if (e.data?.type === 'session:expiring') window.dispatchEvent(new CustomEvent('session:expiring'));
    if (e.data?.type === 'session:expired') window.dispatchEvent(new CustomEvent('session:expired'));
  });

  // también reacciona a cambios de storage (por seguridad)
  window.addEventListener('storage', (ev) => {
    if (ev.key === 'ls.authorizationData') schedule(minutesBefore);
  });
};

export const stopSessionTimer = () => { unsub?.(); unsub = null; clearTimers(); };
